const consentButtons = [...document.querySelectorAll('.js-toggle-cookie-consent')]

consentButtons.map(button => {
    button.addEventListener('click', () => {
    	window.ppms && ppms.cm.api('trackMainFormView', console.log, console.warn)
    	window.OneTrust && OneTrust.ToggleInfoDisplay()
    })
    button.addEventListener('click', preventLink)
})

function preventLink(e) {  
    e.preventDefault()
}